'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('batchListController', function($rootScope, $scope, $state, $stateParams, $http, Restangular, accessControl, uuid) {
    /***************************/
    /***** Setup Variables *****/
    /***************************/

    $scope.moment = moment;
    $scope.listItems = [];
    $scope.listCount = 0;
    $scope.docketsLoading = false;

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    /***********************/
    /***** Permissions *****/
    /***********************/

    /* F/E Permission Checking */
    $scope.userHasPermission = function(permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    /*************************/
    /***** Batches Lists *****/
    /*************************/

    $scope.$parent.loadBatchesListFromParent = function(list, count) {
      $scope.listItems = list;
      $scope.listCount = count;
    }

    /**************************************************/
    /***** Alert parent controller of ready state *****/
    /**************************************************/

    $scope.$parent.batchChildControllerReady();

});



// WEBPACK FOOTER //
// ./src/controllers/batches/batchListController.js